import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reopenProjet } from '../../api/PROJETS/projets';


export const useReopenProjet = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: reopenProjet,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projets'] });
    },
  });
};
